export default "__VITE_ASSET__DdvAuUxI__"